import axios from '../axios'
import URL from '@/_url_'
import qs from 'qs'

let lang = localStorage.lang;

export default {
    state: {
        // ******** 页头数据 ************
        // 
        middle_nav: [], // 中间导航栏内容
        remote_search: [], // 搜索结果
        // 
        // ******** 页脚数据 ************
        // 
        column1: [],// 帮助中心
        column2: [],// 服务支持
        column3: [],// 线下门店
        column4: [],// 店铺加盟
        // 
        friendly: [],// 友情链接
        cooperation: [],// 合作伙伴

        column_content: {}, // 栏目内容
        // 
        // ******** 其它服务 ************
        // 
        service_goods: [], // 服务商品列表
        repair_list: [], // 维修单列表
        repair_detail: {} // 维修单详情
    },
    mutations: {
        // ******** 页头数据 ************
        // 
        setMiddleNav(state, arg){ // 中间导航栏内容写入
            state.middle_nav = arg;
        },
        setRemoteMethod(state, arg){
            state.remote_search = arg;
        },
        clearRemoteMethod(state){
            state.remote_search = [];
        },
        // 
        // ******** 页脚数据 ************
        // 
        setFooterColumn(state, arg){ // 写入页脚栏目
            state.column1 = arg.column1;
            state.column2 = arg.column2;
            state.column3 = arg.column3;
            state.column4 = arg.column4;
        },
        setFooterLink(state, arg){ // 写入页脚链接
            let { friendly, cooperation } = arg;
            state.friendly = friendly;
            state.cooperation = cooperation;
        },

        setColumnContent(state, arg){ // 写入栏目内容
            state.column_content = arg;
        },
        clearColumnContent(state){ // 清除栏目内容
            state.column_content = {};
        },
        // 
        // ******** 其它服务 ************
        // 
        setServiceGoods(state, arg){
            state.service_goods = arg;
        },
        setRepairList(state, arg){
            state.repair_list = arg;
        },
        setRepairDetail(state, arg){
            state.repair_detail = arg;
        }
    },
    actions: {
        // ******** 页头数据 ************
        // 
        getMiddleNav(context){ // 获取中间导航栏内容
            let url = "/index/index/fast?lang="+lang;
            axios.get(url).then((res) => {
                let { code, fast } = res.data
                if(code == 1){
                    context.commit("setMiddleNav",fast);
                }
            }).catch(() => {})
        },
        getRemoteMethod(context,arg){ // 搜索框关键字同步获取
            context.commit("clearRemoteMethod");
            return new Promise((resolve, reject) => {
                let url = "/index/search/sear",
                data = qs.stringify({
                    lang,
                    search: arg
                })
                axios({
                    method: "post",
                    url,
                    data
                }).then((res) => {
                    if(res.data.code == 1){
                        context.commit("setRemoteMethod", res.data.list);
                        resolve()
                    }
                }).catch(() => {})  
            });
                
        },
        // 
        // ******** 页脚数据 ************
        // 
        getFooterColumn({commit}){ // 获取页脚栏目
            let url = "/index/footer/column?lang="+lang;
            axios.get(url).then((res) => {
                if(res.data.code == 1){
                    commit("setFooterColumn",res.data);
                }
            }).catch(() => {})
        },
        getFooterLink({commit}){ // 获取页脚链接
            let f_url = "/index/footer/link?lang="+lang,
            c_url = "/index/footer/cooperation?lang="+lang;
            // 请求函数
            function getFriendly(){
                return axios.get(f_url);
            }
            function getCooperation(){
                return axios.get(c_url);
            }
            // 发起请求
            axios.all([getFriendly(),getCooperation()])
            .then(axios.spread((res1,res2) => {
                let { code: code1, link } = res1.data,
                { code: code2, cooperationlist } = res2.data,
                arg = {};
                if(code1 == 1){
                    arg.friendly = link;
                }
                if(code2 == 1){
                    arg.cooperation = cooperationlist
                }
                commit("setFooterLink", arg)
            })).catch(() => {})
        },

        getColumnContent({commit}, arg){ // 获取栏目内容
            commit("handleLoading", true); // 开启加载动画
            commit("clearColumnContent"); // 清空栏目内容
            let url = "/index/header/column?lang="+lang+"&id="+arg;
            axios.get(url).then((res) => {
                if(res.data.code == 1){
                    commit("setColumnContent", res.data.column);
                    commit("handleLoading", false); // 关闭动画
                }
            }).catch(err => {
                commit("handleLoading", false);
                alert(`获取栏目内容接口异常：${err}，请联系管理员`);
            })
        },
        // 
        // ******** 其它服务 ************
        // 
        getServiceGoods({commit}){ // 获取服务商品列表
            let url = "/index/service/service_good?lang=" + lang;
            axios.get(url).then((res) => {
                if(res.data.code == 1){
                    commit("setServiceGoods", res.data.good)
                }
            }).catch(() => {})
        },
        getRepairList({commit}){ // 获取维修单列表
            commit("handleLoading", true);
            let url = "/index/service/service_list?lang=" + lang;
            axios.get(url).then((res) => {
                commit("handleLoading", false);
                if(res.data.code == 1){
                    commit("setRepairList", res.data.service)
                }
            }).catch(err => {
                commit("handleLoading", false);
                alert(`获取维修单列表接口异常：${err}，请联系管理员`);
            })
        },
        getRepairAgreement({commit}){ // 获取维修协议
            commit("handleLoading", true);
            commit("setColumnContent", {});
            let url = "/index/service/service_column?lang=" + lang;
            axios.get(url).then(res => {
                commit("handleLoading", false);
                if(res.data.code == 1){
                    commit("setColumnContent", res.data.column);
                }
            }).catch(err => {
                commit("handleLoading", false);
                alert(`获取维修协议接口异常：${err}，请联系管理员`);
            })
        },
        handleSubmitRepair({commit}, arg){ // 提交维修单
            commit("handleLoading", true);
            let { pro_id, type, number, this_website, invoice_number, buy_day, is_repair, contact, phone, email, reason, address, companyname } = arg,
            url = "/index/service/service_add",
            data = qs.stringify({
                pro_id,
                type,
                number,
                this_website,
                invoice_number,
                buy_day,
                is_repair,
                contact,
                phone,
                email,
                reason,
                address,
                companyname
            })
            return new Promise( resolve => {
                axios({
                    method: "POST",
                    url,
                    data
                }).then( res => {
                    commit("handleLoading", false);
                    resolve({
                        type: res.data.code === 1,
                        msg: res.data.msg
                    })
                }).catch(err => {
                    commit("handleLoading", false);
                    alert(`提交维修单接口异常：${err}，请联系管理员`);
                })
            })
        },
        getRepairDetail({commit}, arg){ // 获取维修单详情
            commit("handleLoading", true);
            commit("setRepairDetail", {});
            let url = "/index/service/service_detail?lang="+ lang+ "&id="+ arg;
            axios.get(url).then(res => {
                commit("handleLoading", false);
                if(res.data.code == 1) commit("setRepairDetail", res.data.service);
            }).catch(err => {
                commit("handleLoading", false);
                alert(`获取维修单详情接口异常：${err}，请联系管理员`);
            })
        }
    }
}